import { Card } from 'components';

interface SubscriptionPeriodSelectorProps {
  period: 'Mensual' | 'Anual';
  onChangePeriod: (newPeriod: 'Mensual' | 'Anual') => void;
}

export const SubscriptionPeriodSelector = ({
  period,
  onChangePeriod,
}: SubscriptionPeriodSelectorProps) => {
  return (
    <Card WrapperClassName="add-subscription__container-period">
      <div className="add-subscription__radio-group">
        <label>
          <input
            type="radio"
            value="Mensual"
            checked={period === 'Mensual'}
            onChange={() => onChangePeriod('Mensual')}
          />
          <span className="custom-radio"></span> MENSUAL
        </label>
        <label>
          <input
            type="radio"
            value="Anual"
            checked={period === 'Anual'}
            onChange={() => onChangePeriod('Anual')}
          />
          <span className="custom-radio"></span> ANUAL
        </label>
      </div>
    </Card>
  );
};
